// NOTE all the paths MUST be relative. DO NOT START THEM WITH '/'

const BASE_ROUTE = 'authorization'

export const ROUTE_NAMES = {
  ROLES: 'roles',
  PERMISSIONS: 'permissions'
}

const ROUTES = {
  [BASE_ROUTE]: {
    name: BASE_ROUTE,
    path: 'authorization'
  },
  [ROUTE_NAMES.ROLES]: {
    name: ROUTE_NAMES.ROLES,
    path: 'roles'
  },
  [ROUTE_NAMES.PERMISSIONS]: {
    name: ROUTE_NAMES.PERMISSIONS,
    path: 'permissions'
  }
}

export default [
  {
    name: ROUTES[BASE_ROUTE].name,
    path: ROUTES[BASE_ROUTE].path,
    component: {
      template: '<router-view/>',
      name: 'AuthorizationModule'
    },
    children: [
      {
        name: ROUTES[ROUTE_NAMES.ROLES].name,
        path: ROUTES[ROUTE_NAMES.ROLES].path,
        component: (resolve) => require(['./views/roles'], resolve)
      },
      {
        name: ROUTES[ROUTE_NAMES.PERMISSIONS].name,
        path: ROUTES[ROUTE_NAMES.PERMISSIONS].path,
        component: (resolve) => require(['./views/permissions'], resolve)
      }
    ]
  }
]
